export default __webpack_public_path__ + "static/Planet_British_Standard-9e56cc3a36207265c2e5b49b4fa3dd05.svg";